export default __webpack_public_path__ + "static/media/VT323-Regular.1d510e1c.ttf";